import { createSearchParamsCache, parseAsArrayOf, parseAsFloat, parseAsString } from "nuqs/server";

export const blogsQueryParsers = {
  page: parseAsFloat.withDefault(1),
  limit: parseAsFloat.withDefault(10),
  categories: parseAsArrayOf(parseAsString, ",").withDefault([]),
};
export const blogsQueryCache = createSearchParamsCache(blogsQueryParsers);
